<template>
  <search-custom-dropdown
    v-model="searchInput.bedBathBtn.state"
    :search-input-text="searchInput.bedBathBtn.text"
    :is-filled="
      lastNewQuery.query.Beds || lastNewQuery.query.Baths ? true : false
    "
    :width="120"
  >
    <template v-slot:drop-content>
      <bed-bath-value-selector
        :search-object="searchObject"
        :last-new-query="lastNewQuery"
        @bed-bath-selected="onBedBathSelected"
      />
    </template>
  </search-custom-dropdown>
</template>

<script>
import searchLayoutHandler from '../../../mixins/searchLayoutHandler'
import BedBathValueSelector from './BedBathValueSelector.vue'

export default {
  components: { BedBathValueSelector },

  mixins: [searchLayoutHandler],

  props: {
    btnObject: {
      type: Object,
      default: () => ({ text: 'All Beds & Baths', state: false })
    }
  }
}
</script>
